import React from 'react';
import PropTypes from 'prop-types';

import File from './File';

/**
 * Create the View needed for the accordion
 * @param {Array} literature array of literature items
 */

const sortLiterature = lit => lit.sort((a, b) => a.weight - b.weight);

export const createFileViews = literature => {
  if (literature && literature.length > 0) {
    return sortLiterature(literature).map(lit => (
      <File key={lit.id} name={lit.name} size={lit.size} to={lit.fileName} />
    ));
  }
};

// gathers sub category data by section
export const handleSubCategories = (selectedSubs, allSubs) => {
  if (selectedSubs && selectedSubs.length === 0) return;
  const complied = [];

  allSubs.forEach(category => {
    if (selectedSubs.includes(category.categoryId)) {
      complied.push(category);
    }
  });

  return complied;
};

export const litType = PropTypes.arrayOf(
  PropTypes.shape({
    category: PropTypes.string.isRequired,
    rank: PropTypes.number.isRequired,
    literature: PropTypes.arrayOf(
      PropTypes.shape({
        category: PropTypes.shape({
          name: PropTypes.string.isRequired,
          rank: PropTypes.number.isRequired,
          id: PropTypes.string.isRequired
        }),
        fileName: PropTypes.string.isRequired,
        id: PropTypes.string.isRequired,
        name: PropTypes.string.isRequired,
        size: PropTypes.string,
        weight: PropTypes.number
      }).isRequired
    ).isRequired
  }).isRequired
).isRequired;
